module.exports = __webpack_public_path__ + "img/logo_languages.86911982.svg";